import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import LOOKUP from 'constants/lookup';
import { getRecentOrders, getOpenOrders } from 'actions/EntityActions';
import Button from 'screens/components/basic/Button';
import DialogHeaderWithClose from 'screens/components/basic/DialogHeaderWithClose';
import GenericTable from 'screens/components/advanced/GenericTable';
import DialogInput from 'screens/components/advanced/DialogInput';

const dialogStyle = {
    width: '65%',
    maxWidth: 'none'
};
class POSRecentOrdersDialog extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            dialog: true
        };
    }

    componentWillMount = () => {
        // this.props.getRecentOrders();
    }

    componentWillReceiveProps = (newProps) => {
        if (this.props.open !== newProps.open) {
            if (newProps.open === true) {
                this.props.getRecentOrders(this.props.branchId);
                this.props.getOpenedOrders(this.props.branchId);
            }
        }
    }

    reopen = (id) => {
        window.location = `/pos/${id}`;
    }

    render() {
        const { t } = this.props; 
        const p = this.props;
        const recentOrders = this.props.listRecentOrders.map((item, index) => {
            return {
                Id: item.id,
                OnlineOrderId: item.onlineOrderCode,
                PatientId: item.patientId === 0 ? '--' : item.patientId,
                Patient: item.patientFirstName === null ? 'Anonymous' : `${item.patientFirstName} ${item.patientLastName}`,
                Total: `$ ${item.total.toFixed(2)}`,
                Date: item.createdDateString,
                Icons: (<Button
                    key={index}
                    primary={true}
                    label={t('pos.recentOrdersDialog.reopen')}
                    onTouchTap={() => this.reopen(item.id)} />)
            };
        });
        let openedOrders = this.props.listOpenedOrders.map((item, index) => {
            return {
                Id: item.id,
                OnlineOrderId: item.onlineOrderCode,
                PatientId: item.patientId === 0 ? '--' : item.patientId,
                Patient: item.patientFirstName === null ? t('pos.recentOrdersDialog.anonymous') : `${item.patientFirstName} ${item.patientLastName}`,
                Total: `$ ${item.total.toFixed(2)}`,
                Date: item.createdDateString,
                Icons: (
                    <Button
                    className="responsive_btn btnNewBrandPOS"
                    key={index}
                    primary={true}
                    label={t('pos.recentOrdersDialog.continue')}
                    mini={true}
                    onTouchTap={() => this.reopen(item.id)} />
                )
                };
        }).sort((a, b) => a.Id - b.Id);
        
        return (
            <div>
                <DialogInput
                    title={<DialogHeaderWithClose text={t('pos.recentOrdersDialog.openedAndCompletedOrders')} classicClass="posDialogClassic" handleClose={() => this.props.onClose()}/>}
                    modal={true}
                    open={p.open && this.state.dialog}
                    autoScrollBodyContent={true}
                    style={{ zIndex: '950' }}
                    actions={[
                        <Button
                            key={1}
                            type="CancelButton"
                            name="buttonClose"
                            className="btn-space"
                            label={t('common.close')}
                            onTouchTap={() => this.props.onClose()} />]}
                    contentStyle={dialogStyle}>
                        <div className="row">
                            <div className="col-lg-12">
                                <h4 className="purpleText bold">{t('pos.recentOrdersDialog.openOrders')}</h4>
                                <GenericTable
                                    compName="recentOrdersListTable"
                                    className="recent-orders tableHeaderwhiteColorFont"
                                    adjustForCheckbox={false}
                                    displaySelectAll={false}
                                    displayRowCheckbox={false}
                                    enableSelectAll={false}
                                    multiSelectable={false}
                                    selectable={false}
                                    stripedRows={true}
                                    columns={this.props.isMedical ?  [
                                        { key: "Id", label: t("constants.orderNumber"), visibleMode: "visible-lg visible-xs visible-sm visible-md" },
                                        { key: "PatientId", label: t("constants.memberNum"), visibleMode: "visible-lg visible-xs visible-sm visible-md" },
                                        { key: "Patient", label: t("common.member"), visibleMode: "visible-lg" },
                                        { key: "Total", label: t("common.total"), visibleMode: "visible-lg" },
                                        { key: "Date", label: t("constants.dateAndTime"), visibleMode: "visible-lg visible-xs visible-sm visible-md" },
                                        { key: "Icons", label: "", visibleMode: "visible-lg visible-xs visible-sm visible-md" }
                                      ] : [
                                        { key: "Id", label: t("constants.orderNumber"), visibleMode: "visible-lg visible-xs visible-sm visible-md" },
                                        { key: "OnlineOrderId", label: t("constants.queuedOrderNumber"), visibleMode: "visible-lg visible-xs visible-sm visible-md" },
                                        { key: "Patient", label: t("common.member"), visibleMode: "visible-lg visible-xs visible-sm visible-md" },
                                        { key: "Total", label: t("common.total"), visibleMode: "visible-lg visible-xs visible-sm visible-md" },
                                        { key: "Date", label: t("constants.dateAndTime"), visibleMode: "visible-lg visible-xs visible-sm visible-md" },
                                        { key: "Icons", label: "", visibleMode: "visible-lg visible-xs visible-sm visible-md" }
                                      ]}
                                    rows={openedOrders} />
                                <hr />
                                <h3 className="purpleText"><strong>{t('pos.recentOrdersDialog.completedOrders')}</strong></h3>
                                <br />
                                <GenericTable
                                    compName="completedOrdersListTable"
                                    className="recent-orders tableHeaderwhiteColorFont"
                                    adjustForCheckbox={false}
                                    displaySelectAll={false}
                                    displayRowCheckbox={false}
                                    enableSelectAll={false}
                                    multiSelectable={false}
                                    selectable={false}
                                    stripedRows={true}
                                    columns={this.props.isMedical ?  [
                                        { key: "Id", label: t("constants.orderNumber"), visibleMode: "visible-lg visible-xs visible-sm visible-md" },
                                        { key: "PatientId", label: t("constants.memberNum"), visibleMode: "visible-lg visible-xs visible-sm visible-md" },
                                        { key: "Patient", label: t("common.member"), visibleMode: "visible-lg" },
                                        { key: "Total", label: t("common.total"), visibleMode: "visible-lg" },
                                        { key: "Date", label: t("constants.dateAndTime"), visibleMode: "visible-lg visible-xs visible-sm visible-md" },
                                        { key: "Icons", label: "", visibleMode: "visible-lg visible-xs visible-sm visible-md" }
                                      ] : [
                                        { key: "Id", label: t("constants.orderNumber"), visibleMode: "visible-lg visible-xs visible-sm visible-md" },
                                        { key: "OnlineOrderId", label: t("constants.queuedOrderNumber"), visibleMode: "visible-lg visible-xs visible-sm visible-md" },
                                        { key: "Patient", label: t("common.member"), visibleMode: "visible-lg visible-xs visible-sm visible-md" },
                                        { key: "Total", label: t("common.total"), visibleMode: "visible-lg visible-xs visible-sm visible-md" },
                                        { key: "Date", label: t("constants.dateAndTime"), visibleMode: "visible-lg visible-xs visible-sm visible-md" },
                                        { key: "Icons", label: "", visibleMode: "visible-lg visible-xs visible-sm visible-md" }
                                      ]}
                                    rows={recentOrders} />
                            </div>
                        </div>
                </DialogInput>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        listRecentOrders: state.entity.recentOrdersList || [],
        listOpenedOrders: state.entity.openOrdersList || [],
        branchId: state.common.branchId,
        isMedical: state.common.applicationSettings.isMedical
    };
}

function mapDispatchToProps(dispatch) {
    return {
        getRecentOrders: (branchId) => dispatch(getRecentOrders(branchId)),
        getOpenedOrders: (branchId) => dispatch(getOpenOrders(branchId, 1, 100))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSRecentOrdersDialog))